<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners" class="message-rule-dialog">
    <div class="dialog-body">
      <!-- 规则消息 -->
      <el-form :model="form" ref="form" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_message_rule_dialog.gui_ze_ming_cheng')" prop="ruleName">
              <el-input v-model="form.ruleName" :disabled="isShow"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_message_rule_dialog.xiao_xi_ming_cheng')" prop="triggerCode">
              <custom-select
                :disabled="isShow"
                v-model="form.triggerCode"
                url="pushConfRuleSelect"
                :params="{ triggerCode: model.data.item.triggerCode }"
                :props="{ label: 'triggerCodeName', value: 'triggerCode' }"
                :placeholder="$t('Common.com_please_select')"
                filterable
                remote
                clearable
                reserveKeyword
                @change="handleNodeClick"
              ></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 规则配置 -->
      <div class="handle-role">
        <el-form>
          <el-form-item class="is-required" :label="$t('base_message_rule_dialog.chu_fa_tiao_jian')" prop="connectSymbol">
            <el-radio-group v-model="form.connectSymbol" style="margin-left: 20px" :disabled="isShow">
              <el-radio :label="1">{{ $t('base_message_rule_dialog.ren_yi_tiao_jian') }}</el-radio>
              <el-radio :label="2">{{ $t('base_message_rule_dialog.suo_you_tiao_jian') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="role-list">
          <ul>
            <li v-for="(item, index) in form.conditionList" :key="index">
              <div class="item ub">
                <el-row :gutter="10" class="ub-f1">
                  <el-col :span="9">
                    <!-- 推送条件 -->
                    <el-select v-model="item.paramCode" :disabled="isShow" :placeholder="$t('base_message_rule_dialog.tiao_jian')" width="100%">
                      <el-option v-for="items in msgBizList" :key="items.value" :label="items.name" :value="items.value"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <!-- 匹配条件 -->
                    <custom-select v-model="item.symbol" :disabled="isShow" code="bas_msg_symbol" :placeholder="$t('base_message_rule_dialog.fu_hao')" width="100%"></custom-select>
                  </el-col>
                  <el-col :span="10">
                    <el-input :disabled="isShow" v-model="item.conditionValue" :placeholder="$t('base_message_rule_dialog.zhi')" style="width: 100%"></el-input>
                  </el-col>
                </el-row>
                <div v-if="!isShow" class="icon-box" @click="deleteRuleItem(index)">
                  <i class="icon icon-shanchu"></i>
                </div>
              </div>
              <div class="bottom"></div>
            </li>
          </ul>
        </div>
        <div v-if="!isShow" class="role-add-btn" @click="addRuleItem">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>{{ $t('Common.com_added') }}</span>
          </div>
        </div>
      </div>
      <!-- 其他配置 -->
      <div class="other-role">
        <el-form :model="form" ref="form1" :rules="rules">
          <el-form-item :label="$t('Common.com_status')" prop="state">
            <custom-select v-model="form.state" code="cloud_common_state" :clearable="false" placeholder="" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('base_message_rule_dialog.sheng_xiao_shi_jian')" prop="dataTimes">
            <custom-date-picker
              :disabled="isShow"
              v-model="form.dataTimes"
              align="right"
              type="daterange"
              value-format="YYYY-MM-DD HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="beforeToday"
            ></custom-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="savePushRule">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      loadingCode: false,
      isShow: false,
      triggerOptions: [],
      formItem: {
        paramCode: '',
        // paramName: '',
        // pushConditionId: '',
        // pushRuleId: '',
        symbol: '',
        conditionValue: '',
      },
      msgBizList: [],
      form: {
        ruleId: '',
        state: 1,
        // conditionExpression: '',
        conditionList: [],
        connectSymbol: 1,
        effectTimeEnd: '',
        effectTimeStart: '',
        ruleCode: '',
        ruleName: '',
        ruleType: '',
        triggerCode: '',
        triggerInterval: null,
        triggerNum: null,
        dataTimes: [],
      },
    };
  },
  computed: {
    rules() {
      return {
        state: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        ruleName: {
          required: true,
          message: this.$t('base_message_rule_dialog.gzmcbt'),
        },
        triggerCode: {
          required: true,
          message: this.$t('base_message_rule_dialog.xxmcbx'),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
    this.remoteMethod();
    this.getDictionary('bas_msg_biz_type');
  },
  methods: {
    // 选中树
    handleNodeClick: function (row) {
      this.form.conditionList = [JSON.parse(JSON.stringify(this.formItem))];
      const dic = this.propertyMap.bas_msg_biz_type.find((item) => item.value === row.msgBizCode);
      this.msgBizList = dic ? dic.children : [];
    },
    // 初始化
    initDialog: function () {
      this.isShow = !!this.model.data.isShow;
      if (this.model.type === 'edit' || this.model.type === 'show') {
        this.getPushRuleDetail(this.model.data.item.ruleId);
      }
    },
    getPushRuleDetail: function (ruleId) {
      this.$getJSON(`${apis.PushRuleInfo}/${ruleId}`).then((res) => {
        const data = res.data;
        if (data.effectTimeStart && data.effectTimeEnd) {
          data.dataTimes = [data.effectTimeStart, data.effectTimeEnd];
        }
        data.state = data.state ? 1 : 0;
        this.$setFormatData(this.form, data);
        this.remoteMethod();
        this.getDictionary('bas_msg_biz_type', () => {
          const dic = this.propertyMap.bas_msg_biz_type.find((item) => item.value === data.msgBizCode);
          this.msgBizList = dic ? dic.children : [];
        });
      });
    },
    // 新增规则项
    addRuleItem: function () {
      this.form.conditionList.push(JSON.parse(JSON.stringify(this.formItem)));
    },
    // 删除规则项
    deleteRuleItem: function (index) {
      this.form.conditionList.splice(index, 1);
    },
    clearTriggerCode: function () {
      this.remoteMethod();
      this.triggerOptions = [];
      this.form.triggerCode = '';
    },
    // 远程加载消息名称下拉项
    remoteMethod: function (query) {
      this.loadingCode = true;
      this.$getJSON(apis.pushConfRuleSelect).then((res) => {
        this.loadingCode = false;
        const list = res.data;
        this.triggerOptions = query ? list.filter((item) => item.triggerCodeName.toLowerCase().indexOf(query.toLowerCase()) > -1) : list;
      });
    },
    savePushRule: function () {
      if (this.model.data.isShow) {
        this.visible = false;
        return;
      }
      this.$refs.form.validate((valid) => {
        this.$refs.form1.validate((valid1) => {
          if (!valid || !valid1) {
            return;
          }
          this.form.conditionList = this.form.conditionList.filter((t) => t.paramCode || t.symbol || t.conditionValue);
          if (this.form.conditionList.length === 0) {
            this.$message.error(this.$t('base_message_rule_dialog.cftjbt'));
            return;
          }
          const hasEmpty = this.form.conditionList.find((t) => !t.paramCode || !t.symbol || !t.conditionValue);
          if (hasEmpty) {
            this.$message.error(this.$t('base_message_rule_dialog.qwztxcftj'));
            return;
          }
          // this.form.effectTimeStart = moment(this.form.dataTimes[0]).format('YYYY-MM-DD HH:mm');
          // this.form.effectTimeEnd = moment(this.form.dataTimes[1]).format('YYYY-MM-DD HH:mm');
          this.form.effectTimeStart = this.form.dataTimes[0];
          this.form.effectTimeEnd = this.form.dataTimes[1];
          this.form.conditionList = this.form.conditionList.filter((t) => t.paramCode && t.symbol && t.conditionValue);
          if (this.model.type === 'add') {
            this.saveAddPushRule();
          }
          if (this.model.type === 'edit') {
            this.saveEditPushRule();
          }
        });
      });
    },
    // 保存新增推送规则
    saveAddPushRule: function () {
      this.$postJSON(apis.PushRuleSave, Object.assign({}, this.form, { state: this.form.state === '1' }), true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑推送规则
    saveEditPushRule: function () {
      this.$postJSON(apis.PushRuleSave, Object.assign({}, this.form, { state: this.form.state === '1' }), true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.message-rule-dialog {
  .title {
    line-height: 24px;
    font-size: 14px;
    padding-left: 10px;
    position: relative;
    color: #595959;
    margin-bottom: 18px;
  }
  .title .bar {
    width: 3px;
    height: 13px;
    background-color: #00afff;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .role-list {
    ul li {
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
    .item {
      height: 50px;
      padding: 10px;
      background: rgba(245, 245, 245, 1);
      border: 1px solid rgba(228, 228, 228, 1);
      .icon-box {
        line-height: 30px;
        width: 30px;
        margin-left: 10px;
        text-align: center;
        cursor: pointer;
        .icon {
          color: #00afff;
          font-size: 14px;
        }
      }
    }
    $h: 28px;
    .el-input__inner {
      height: $h;
      line-height: $h;
    }
    .el-input__icon {
      line-height: $h !important;
    }
  }
  .other-role {
    margin-top: 18px;
  }
  .role-add-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px solid rgba(228, 228, 228, 1);
    line-height: 38px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
}
</style>
